var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"75.468","height":"96.886","viewBox":"0 0 75.468 96.886"}},[_c('path',{attrs:{"id":"Path_245","data-name":"Path 245","d":"M4747,5601v95.886h-73.834l41.951-45.931-37.7-49.956Z","transform":"translate(-4672.032 -5600.5)","fill":"#f9850c","stroke":"#872709","stroke-width":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }